(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.facets-layout li').forEach(li => {
  const input = li.querySelector('input[value="Vases"]');

  if (input) {
    li.remove();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    //  $(document).ready(function(){
//   $('.product__media-list').owlCarousel({
//     loop:false,
//     nav:true,
//     dots:false,
//     items:1,
//     navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M6.64645 13.3496C6.84171 13.5449 7.15829 13.5449 7.35355 13.3496C7.54882 13.1544 7.54882 12.8378 7.35355 12.6425L6.64645 13.3496ZM1 6.99609L0.646447 6.64254C0.451184 6.8378 0.451184 7.15438 0.646447 7.34964L1 6.99609ZM7.35355 1.34969C7.54882 1.15439 7.54882 0.837794 7.35355 0.642494C7.15829 0.447294 6.84171 0.447294 6.64645 0.642494L7.35355 1.34969ZM7.35355 12.6425L1.35355 6.64254L0.646447 7.34964L6.64645 13.3496L7.35355 12.6425ZM1.35355 7.34964L7.35355 1.34969L6.64645 0.642494L0.646447 6.64254L1.35355 7.34964Z" fill="#404040"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1.35355 13.3496C1.15829 13.5449 0.84171 13.5449 0.64645 13.3496C0.45118 13.1544 0.45118 12.8378 0.64645 12.6425L1.35355 13.3496ZM7 6.99609L7.35355 6.64254C7.54882 6.8378 7.54882 7.15438 7.35355 7.34964L7 6.99609ZM0.646451 1.34969C0.451181 1.15439 0.451181 0.837794 0.646451 0.642494C0.841711 0.447294 1.15829 0.447294 1.35355 0.642494L0.646451 1.34969ZM0.64645 12.6425L6.64645 6.64254L7.35355 7.34964L1.35355 13.3496L0.64645 12.6425ZM6.64645 7.34964L0.646451 1.34969L1.35355 0.642494L7.35355 6.64254L6.64645 7.34964Z" fill="#404040"/></svg>']
//   })
//  })
  } catch(e) { console.error(e); }
})();

})();
